import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";
import { getAxiosCancelToken } from "../../utils/getAxiosCancelToken";

let cancelToken;
const getSearchClassTags = (searchText) => {
  cancelToken = getAxiosCancelToken(cancelToken);
  return apiRequestType(
    apiTypes.GET,
    apiConstants.MANAGE.GET_SEARCH_CLASS_TAGS(searchText),
    "",
    cancelToken
  );
};

export default getSearchClassTags;
